import { useGameStore } from '../store';
import {
  playToggle,
  ensureAudioContext,
} from '../sounds';
import { trackEvent } from '../analytics';

/**
 * Reusable audio/global settings rows.
 * Used inside both the TopBar settings popup and the tutorial settings preview.
 */
export function AudioSettings() {
  const soundOn = useGameStore((s) => s.soundEnabled);
  const toggleSound = useGameStore((s) => s.toggleSound);

  return (
    <>
      <button
        className="top-bar-setting-row"
        onClick={() => {
          ensureAudioContext();
          playToggle();
          const next = toggleSound();
          trackEvent('sound_toggle', { enabled: next });
        }}
      >
        <div className="top-bar-setting-info">
          <span className="top-bar-setting-label">Sound Effects</span>
          <span className="top-bar-setting-desc">
            Play feedback sounds while solving
          </span>
        </div>
        <div
          className={`top-bar-setting-toggle${soundOn ? ' top-bar-setting-toggle--on' : ''}`}
          aria-hidden="true"
        >
          <div className="top-bar-setting-knob" />
        </div>
      </button>
    </>
  );
}

export function SettingsGearIcon({ size = 18 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path
        d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065"
      />
      <path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
    </svg>
  );
}

export function BugIcon({ size = 18 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M9 9V7a3 3 0 1 1 6 0v2" />
      <rect x="7" y="9" width="10" height="11" rx="5" />
      <path d="M12 13v7" />
      <path d="M4 13h3" />
      <path d="M17 13h3" />
      <path d="M5 8l2 2" />
      <path d="M19 8l-2 2" />
      <path d="M5 20l2 -2" />
      <path d="M19 20l-2 -2" />
    </svg>
  );
}
